import { bytesToGB, convertToReadable } from "@sscs/utils";
import { GetOrganizationUsageResponse } from "Types";

type UsageAndLimits = {
  downloadCapacity: string;
  analysisCapacityPortalAndCli: string;
  analysisCapacityPortal: string;
  analysisCapacityCli: string;
  analysisFlexCapacity: string;
  analysisCapacityTotal: string;
  hasGroupsWithAndWithoutLimit: boolean;
  groupLimitsSum: number;
  max_package_size: number;
};

export const getHumanReadableOrgLimits = (
  data?: GetOrganizationUsageResponse,
): UsageAndLimits => ({
  downloadCapacity: convertToReadable(data?.download_capacity_bytes),
  analysisCapacityPortalAndCli: convertToReadable(
    (data?.allocation_capacity_bytes_portal ?? 0) +
      (data?.allocation_capacity_bytes_cli ?? 0),
  ),
  max_package_size: Math.round(
    bytesToGB(data?.entitlements?.max_package_size ?? 0),
  ),
  analysisCapacityPortal: convertToReadable(
    data?.allocation_capacity_bytes_portal,
  ),
  analysisCapacityCli: convertToReadable(data?.allocation_capacity_bytes_cli),
  analysisFlexCapacity: convertToReadable(
    data?.organization_flex_capacity_bytes ?? 0,
  ),
  analysisCapacityTotal: convertToReadable(
    (data?.allocation_capacity_bytes_portal ?? 0) +
      (data?.allocation_capacity_bytes_cli ?? 0),
  ),
  hasGroupsWithAndWithoutLimit:
    (data?.groups_with_limits.length ?? 0) > 0 &&
    (data?.groups_without_limits.length ?? 0) > 0,
  groupLimitsSum:
    data?.groups_with_limits.reduce(
      (acc, group) => acc + group.group_limit,
      0,
    ) ?? 0,
});
